import { networkCall } from "../../../../../util/network-call/network-call";

export const CompanyAdminEducationAddLoader = async () => {

    const getModulesResponse = await networkCall('/modules');

    return { getModulesResponse };

};